/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from '../Sidebar.css';
import Link from '../../Link';

class SidebarProducts extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
  };

  render() {
    return (
      <div className={s.root} role="navigation">
        <ul className={s.menu}>
          <li
            className={
              this.props.title === 'Common Solid Bricks' ? s.current : ''
            }
          >
            <Link className={s.link} to="/products/common-solid-bricks">
              Common Solid Bricks
            </Link>
          </li>
          <li className={this.props.title === 'Common Blocks' ? s.current : ''}>
            <Link className={s.link} to="/products/common-blocks">
              Common Blocks
            </Link>
          </li>
          <li
            className={
              this.props.title === 'M211 Modular Bricks' ? s.current : ''
            }
          >
            <Link className={s.link} to="/products/modular-bricks">
              M211 Modular Bricks
            </Link>
          </li>
          <li
            className={
              this.props.title === 'Facing Brick - Rockface' ? s.current : ''
            }
          >
            <Link className={s.link} to="/products/facing-brick-rockface">
              Facing Brick - Rockface
            </Link>
          </li>
          <li
            className={
              this.props.title === 'Facing Brick - Veneer' ? s.current : ''
            }
          >
            <Link className={s.link} to="/products/facing-brick-veneer">
              Facing Brick - Veneer
            </Link>
          </li>
        </ul>
      </div>
    );
  }
}

export default withStyles(s)(SidebarProducts);



// WEBPACK FOOTER //
// ./src/components/Sidebar/Products/Products.js